import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    confirm: 'Yes, delete this contact',
    description:
      'You will no longer be able to send quotes, invoices and reminders to this contact.',
    message: {
      error:
        'An error occurred while deleting your contact. Please try again and if the problem remains, contact us.',
      success: 'Changes successfully saved!',
    },
    title: 'Delete your contact {firstName} {lastName}',
  },
  fr: {
    confirm: 'Oui, supprimer ce contact',
    description:
      'Vous ne pourrez plus envoyer de devis, facture et relance à ce contact.',
    message: {
      error:
        'Une erreur est survenue lors de la suppression de votre contact. Réessayez et si le problème persiste, contactez-nous.',
      success: 'Modifications enregistrées avec succès !',
    },
    title: 'Supprimer votre contact {firstName} {lastName}',
  },
} as const);

export default locales;
